// mui components
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledValue = styled(Typography)(({ theme }) => ({
  ...theme.fontStyles.body,
  color: theme.colors.text.light.placeholder,
}));
